/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_ChatInputs */

const en_us2_clubs_chat = /** @type {(inputs: Clubs_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

const pt_br2_clubs_chat = /** @type {(inputs: Clubs_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa`)
};

const es_419_clubs_chat = /** @type {(inputs: Clubs_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

const pt_pt2_clubs_chat = /** @type {(inputs: Clubs_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa`)
};

const fr_fr2_clubs_chat = /** @type {(inputs: Clubs_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discussion`)
};

const de_de2_clubs_chat = /** @type {(inputs: Clubs_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

const it_it2_clubs_chat = /** @type {(inputs: Clubs_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

/**
* | output |
* | --- |
* | "Chat" |
*
* @param {Clubs_ChatInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_chat = /** @type {((inputs?: Clubs_ChatInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_ChatInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_chat(inputs)
	if (locale === "es-419") return es_419_clubs_chat(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_chat(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_chat(inputs)
	if (locale === "de-DE") return de_de2_clubs_chat(inputs)
	if (locale === "it-IT") return it_it2_clubs_chat(inputs)
	return en_us2_clubs_chat(inputs)
});
export { clubs_chat as "clubs.chat" }